import { z } from 'zod';
import { UIErrorI18nKeyValues } from '@next-is-free-monorepo/i18n';

export const SuccessResponseSchema = z.object({title: z.enum(UIErrorI18nKeyValues), details: z.string().optional()});
export type SuccessResponse = z.infer<typeof SuccessResponseSchema>

export const emailCheckResponseSchema = z.enum(['isShop', 'isNotShop', 'notRegistered']);
export type EmailCheckResponse = z.infer<typeof emailCheckResponseSchema>
